const root = 'api/inbox/agent';
export const AgentInboxEndpoints = {
  AgentDrawer: {
    update: `${root}/drawer/activity/update`,
    initial: `${root}/drawer`
  },
  AgentInbox: {
    overview: `${root}/overview`,
    priorityList: `${root}/priorityList`,
    update: `${root}/update`,
    delete: `${root}/delete`,
    sendToFolio: `${root}/sendToFolio`,
    merge: `${root}/merge`,
    quickAdd: `${root}/quickAdd`,
    assignUser: `${root}/assignUser`,
    selectedActivities: `${root}/selectedActivities`,
    allCounts: `${root}/counts`
  },
  AutoAssign: `${root}/autoassign`,
  AutoAssignAvailable: `${root}/autoassign/available`
};
